import { OfficeStepText } from "./types";

export const OFFICE_INFO_STEP = 0;
export const OFFICE_ADDRESS_STEP = 1;
export const OFFICE_EMAIL_STEP = 2;
export const OFFICE_PHONE_STEP = 3;
export const OFFICE_USER_STEP = 4;
export const OFFICE_NOTE_STEP = 5;
export const OFFICE_SUMMARY_STEP = 6;

/** Naslov prvog koraka ovisi o tome je li poslovnica nova. */
export const OFFICE_INFO_TEXTS = {
  create: {
    title: "Otvorite novu poslovnicu",
    description: "Upišite naziv, šifru i internu oznaku. Po njima se poslovnica prepoznaje u cijelom sustavu.",
  },
  edit: {
    title: "Uredite podatke poslovnice",
    description: "Promijenite naziv, šifru ili opis. Promjena se odmah vidi svugdje gdje se poslovnica koristi.",
  },
};

/** Naslov i objašnjenje ispod scene za ostale korake. */
export const OFFICE_INTRO_TEXTS: Record<number, OfficeStepText> = {
  [OFFICE_ADDRESS_STEP]: {
    title: "Gdje se poslovnica nalazi?",
    description: "Dodajte jednu ili više adresa. Glavnu adresu označite kao primarnu.",
  },
  [OFFICE_EMAIL_STEP]: {
    title: "Kamo stižu mailovi?",
    description: "Dodajte adrese e-pošte poslovnice. Uz svaku upišite opis, pa se zna čemu služi.",
  },
  [OFFICE_PHONE_STEP]: {
    title: "Na koji broj se javljate?",
    description: "Upišite telefone poslovnice. Primarni broj je prvi na koji se zove.",
  },
  [OFFICE_USER_STEP]: {
    title: "Tko radi u poslovnici?",
    description: "Dodajte korisnike koji rade u ovoj poslovnici. Svaki se prijavljuje svojim korisničkim imenom.",
  },
  [OFFICE_NOTE_STEP]: {
    title: "Zapišite što treba znati",
    description: "Bilješke su interne i ostaju uz poslovnicu. Važne bilješke se posebno ističu.",
  },
  [OFFICE_SUMMARY_STEP]: {
    title: "Poslovnica je spremna",
    description: "Provjerite podatke prije završetka. Sve se kasnije može dopuniti.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const OFFICE_INTRO_SAMPLE = {
  name: "Poslovnica Split",
  code: "PU02",
  internalMark: "ST",
  description: "Prodaja i najam vozila za Dalmaciju.",
  otherOffices: ["Poslovnica Zagreb", "Poslovnica Rijeka"],
  addresses: [
    { line: "Poljička cesta 12", city: "21000 Split, Hrvatska", label: "Glavna" },
    { line: "Put Supavla 1", city: "21000 Split, Hrvatska", label: "Parkiralište" },
  ],
  latitude: 43.5081,
  longitude: 16.4402,
  emails: [
    { address: "split@orytron.com", description: "Opći upiti", primary: true },
    { address: "prodaja.st@orytron.com", description: "Prodaja", primary: false },
    { address: "servis.st@orytron.com", description: "Servis", primary: false },
  ],
  phones: [
    { number: "+385 21 345 678", description: "Recepcija", primary: true },
    { number: "+385 91 234 5678", description: "Prodaja", primary: false },
    { number: "+385 98 765 4321", description: "Dežurni", primary: false },
  ],
  users: [
    { name: "Marko Perić", role: "Voditelj poslovnice", initials: "MP" },
    { name: "Ivana Horvat", role: "Prodaja", initials: "IH" },
    { name: "Luka Babić", role: "Najam", initials: "LB" },
  ],
  roles: ["Voditelj", "Prodaja", "Najam"],
  notes: [
    { content: "Ključevi vozila u sefu kod recepcije.", important: true },
    { content: "Subotom radi samo prodaja.", important: false },
  ],
  summary: ["Naziv i šifra", "Adrese", "Mailovi", "Telefoni", "Korisnici", "Bilješke"],
};
